<template>
  <div class="container monitoring-list-container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{
          $t("lbl.loginUser.header")
        }}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <v-row
      class="mb-0 custom-form-control custom-form-control-type-2 custom-form-control-type-4 custom-figma-1"
    >
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
            cols="12"
            xl="7"
            lg="7"
            md="12"
          >
            <v-row class="pt-0 pb-0 mt-0" style="margin-bottom: 28px">
              <v-col cols="12" lg="3" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="userId"
                  :label="$t('lbl.loginUser.conditionSearch.userId')"
                  @keyup.enter="searchData"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="userIp"
                  @keyup.enter="searchData"
                  :label="$t('lbl.loginUser.conditionSearch.userIp')"
                  dense
                  filled
                  hide-details
                  class="custom-selectbox"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="6" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="deviceType"
                  class="custom-selectbox"
                  :label="$t('lbl.loginUser.conditionSearch.deviceTp')"
                  :items="logLvlList"
                  @change="searchData"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>

          <!-- Time Condition -->
          <v-col
            xl="1"
            lg="1"
            md="12"
            class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1"
          >
          </v-col>
          <v-col
            class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1 text-right"
            cols="12"
            xl="4"
            lg="4"
            md="12"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateData"
                    :class="[
                      'date-text',
                      $vuetify.theme.dark ? '' : 'font-semibold',
                    ]"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDateData"
                  @input="
                    fromDate = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.fromdate_menu.save(fromDateData)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromtime_menu"
                v-model="fromTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromTimeData"
                    :class="[
                      'time-text',
                      $vuetify.theme.dark ? '' : 'font-semibold',
                    ]"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('from', $event)"
                    @change="validateTimeInput('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="fromTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromtime_menu = false">{{
                    $t("btn.common.cancel")
                  }}</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.fromtime_menu.save(fromTimeData)"
                    >{{ $t("btn.common.ok") }}</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="toDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateData"
                    :class="[
                      'date-text',
                      $vuetify.theme.dark ? '' : 'font-semibold',
                    ]"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-period-picker"
                  v-model="toDateData"
                  @input="
                    toDate = false;
                    changeDate('to');
                  "
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">{{
                    $t("btn.common.cancel")
                  }}</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.todate_menu.save(toDateData)"
                    >{{ $t("btn.common.ok") }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>

            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="totime_menu"
                v-model="toTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toTimeData"
                    :class="[
                      'time-text',
                      $vuetify.theme.dark ? '' : 'font-semibold',
                    ]"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('to', $event)"
                    @change="validateTimeInput('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-model="toTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="totime_menu = false">{{
                    $t("btn.common.cancel")
                  }}</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.totime_menu.save(toTimeData)"
                    >{{ $t("btn.common.ok") }}</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                class="btn btn-top btn-search btn-width-1"
                color="primary"
                @click="searchData"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon
                >{{ $t("btn.common.search") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Button Action -->
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="8" md="7" class="pl-4">
            <v-btn
              @click="downloadExcel"
              :disabled="!$auth.manage"
              x-small
              class="btn-height-custom btn-excel mb-0"
            >
              {{ $t("btn.monitoring.excel") }}
            </v-btn>
          </v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5"></v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="40"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Grid table List -->
    <v-row>
      <system-progress
        :sysloading="isLoading"
        :sysloadingTitle="sysloadingTitle"
      ></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :footer-props="{
            showFirstLastPage: true,
          }"
          :search="searchByTxt"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          hide-default-footer
          :class="[
            'list-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
        />
      </v-col>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{
                      totalCnt - itemsPerPage * page > 0
                        ? itemsPerPage * page
                        : totalCnt
                    }}
                    of {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <dialogWindow
      ref="Validation"
      :info="checkDialogTitle"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    ></dialogWindow>
  </div>
</template>

<script>
import $ from "jquery";
import { resizeTableHeight } from "@/vue-dlb/common/common";
import { getAppliedTimeZone } from "@/vue-dlb/utils/util";
import { mapState } from "vuex";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";

const moment = require("moment");

export default {
  components: {
    SystemProgress,
    dialogWindow,
  },
  props: {
    items: {
      default: Array,
    },
  },

  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      searchBy: "",
      searchByTxt: "",
      userId: "",
      userIp: "",
      deviceType: "",
      listData: [],
      dialog: false,
      checkDialogColor: "warning",
      checkDialogInfo: "",
      checkDialogTitle: "Alert",
      isCreated: false,
      tableHeight: "",
      rowPerPage: [
        { value: 10, text: "Show 10" },
        { value: 25, text: "Show 25" },
        { value: 50, text: "Show 50" },
        { value: 75, text: "Show 75" },
        { value: 100, text: "Show 100" },
      ],
      fromDateData: getAppliedTimeZone(),
      fromDate: false,
      fromTimeData: "00:00",
      fromTime: false,
      toDateData: getAppliedTimeZone(),
      toDate: false,
      toTimeData: "23:59",
      toTime: false,
      timeRange: 0,
      logLvlList: ["All", "PC", "Mobile"],
      isLoading: false,
      totalCnt: 0,
      pageEnter: 1,
      gmtTmzn: "",
    };
  },

  computed: {
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
    getMaxDate() {
      return getAppliedTimeZone();
    },
    getMinDate() {
      return this.fromDateData;
    },
    headers() {
      let headers = [
        {
          text: "Session ID",
          value: "session_id",
          align: "left",
          width: 150,
        },
        { text: "User ID", value: "usr_id", align: "left", width: 150 },
        {
          text: "User IP",
          value: "usr_ip",
          align: "left",
          width: 150,
        },
        { text: "Login Time", value: "login_dt", align: "center", width: 160 },

        {
          text: "Logout Time",
          value: "logout_dt",
          align: "center",
          width: 160,
        },
        { text: "Browser Information", value: "browser_info", align: "left" },
        {
          text: "Device Type",
          value: "device_type",
          align: "left",
          width: 120,
        },
      ];
      return headers;
    },
  },

  watch: {
    page() {
      this.pageEnter = this.page;
    },
  },

  async created() {
    this.searchData();
    this.isCreated = true;
  },
  updated: function () {
    let self = this;
    let arrClassMinus = [".page-control-content"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + "px";
    });
  },
  mounted() {},

  methods: {
    closeDialog() {
      this.$refs.Validation.dialog = false;
    },
    downloadExcel() {
      const tmpListData = this.$store.getters.userLoginHistoryList;
      if (tmpListData.length > 0) this.generateExcelFile(tmpListData);
    },
    generateExcelFile(excelData) {
      const excel = require("node-excel-export");
      const styles = {
        headerDark: {
          fill: {
            fgColor: {
              rgb: "FF496D94",
            },
          },
          font: {
            color: {
              rgb: "FFFFFFFF",
            },
            sz: 14,
          },
        },
      };

      const specification = {
        session_id: {
          displayName: "Session ID",
          headerStyle: styles.headerDark,
          width: 370,
        },
        usr_id: {
          displayName: "User ID",
          headerStyle: styles.headerDark,
          width: 170,
        },
        usr_ip: {
          displayName: "User IP",
          headerStyle: styles.headerDark,
          width: 110,
        },
        login_dt: {
          displayName: "Login Time",
          headerStyle: styles.headerDark,
          width: 150,
        },
        logout_dt: {
          displayName: "Logout Time",
          headerStyle: styles.headerDark,
          width: 150,
        },
        browser_info: {
          displayName: "Browser Information",
          headerStyle: styles.headerDark,
          width: 310,
        },
        device_type: {
          displayName: "Device Type",
          headerStyle: styles.headerDark,
          width: 110,
        },
      };

      const report = excel.buildExport([
        {
          name: "Login User Monitoring",
          heading: [],
          merges: [],
          specification: specification,
          data: excelData,
        },
      ]);

      var data = new Blob([report.buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      var url = window.URL.createObjectURL(data);
      var a = document.createElement("a");
      a.href = url;
      a.download = "Login_User_Monitoring.xlsx";
      document.body.appendChild(a);
      a.click();
    },
    validateTimeInput(side) {
      let timeString = side === "from" ? this.fromTimeData : this.toTimeData;
      var isValid = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(
        timeString
      );
      if (!isValid) {
        this.$refs.validateDate.dialog = true;
        side === "from"
          ? (this.fromTimeData = "00:00")
          : (this.toTimeData = "23:59");
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = side === "from" ? this.fromDateData : this.toDateData;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes("-")) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === "-" &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += "-";
        side === "from"
          ? (this.fromDateData = dateString)
          : (this.toDateData = dateString);
      } else {
        return true;
      }
    },
    formatTime(side, evt) {
      let timeString = side === "from" ? this.fromTimeData : this.toTimeData;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45 &&
        charCode !== 58
      ) {
        evt.preventDefault();
      } else if (
        charCode !== 46 &&
        charCode !== 8 &&
        charCode !== 58 &&
        timeString.length === 2 &&
        !timeString.includes(":")
      ) {
        timeString += ":";
        side === "from"
          ? (this.fromTimeData = timeString)
          : (this.toTimeData = timeString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === "from") {
        if (!this.validateDateInput(this.fromDateData)) {
          this.$refs.validateDate.dialog = true;
          this.fromDateData = getAppliedTimeZone();
          this.toDateData = getAppliedTimeZone();
          return;
        }
        if (this.fromDateData > this.toDateData) {
          this.toDateData = this.fromDateData;
        }
      }
      if (side === "to") {
        if (!this.validateDateInput(this.toDateData)) {
          this.$refs.validateDate.dialog = true;
          this.toDateData = getAppliedTimeZone();
          this.fromDateData = getAppliedTimeZone();
          return;
        }
        if (this.fromDateData > this.toDateData) {
          this.fromDateData = this.toDateData;
        }
      }
    },
    getParamData() {
      let params = {
        userId: this.userId,
        userIp: this.userIp,
        deviceType: this.deviceType === 'Mobile' ? 'MO' : this.deviceType,
        pageRows: this.itemsPerPage,
        pageNum: this.page,
      };

      const fromDate = this.applyGmtTimeZoneForSrchcond(
        this.fromDateData + " " + this.fromTimeData
      );
      const toDate = this.applyGmtTimeZoneForSrchcond(
        this.toDateData + " " + this.toTimeData
      );
      params.fromDate = fromDate;
      params.toDate = toDate;
      this.timeRange =
        (new Date(toDate.replace(/-/g, "/")) -
          new Date(fromDate.replace(/-/g, "/"))) /
        (24 * 60 * 60 * 1000);

      Object.keys(params).forEach((key) => {
        if (
          params[key] === null ||
          params[key] === undefined ||
          params[key] === "" ||
          params[key] === "All"
        ) {
          delete params[key];
        }
      });
      return params;
    },
    searchData() {
      const params = this.getParamData();
      if (this.timeRange > 7) {
        this.isLoading = false;
        this.$refs.Validation.dialog = true;
        this.checkDialogColor = "validation";
        this.checkDialogTitle = "Search";
        this.checkDialogInfo = this.$t("msg.systemLog.dateValidate");
      } else {
        this.getDataList(params);
      }
    },
    getDataList(params) {
      this.isLoading = true;
      this.$store
        .dispatch("getLoginUserHistoryList", params)
        .then(() => {
          this.listData = this.$store.getters.userLoginHistoryList;
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
          this.page = 1;
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },

    applyGmtTimeZone(date) {
      let newM = "";
      if (date !== undefined && date !== "") {
        newM = moment(date)
          .add(this.gmtTmzn, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },
    applyGmtTimeZoneForSrchcond(date) {
      let newM = "";
      this.gmtTmzn = this.$cookies.get("gmt-timezone");
      if (date !== undefined && date !== "") {
        if (this.gmtTmzn.indexOf(`+`) === 0)
          newM = moment(date)
            .subtract(this.gmtTmzn, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
        else if (this.gmtTmzn.indexOf(`-`) === 0)
          newM = moment(date)
            .add(this.gmtTmzn, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },

    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },

    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page =
          data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
  },
};
</script>

<style scoped>
</style>
